import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getVideo, updateLike, updateUnlike } from "./videoAPI";
const initialState = {
  video: {},
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchVideo = createAsyncThunk("video/fetchVideo", async (id) => {
  const video = await getVideo(id);
  return video;
});

export const fetchLike = createAsyncThunk("video/fetchLike", async ({ id, likes }) => {
  const video = await updateLike(id, likes);
  return video;
});

export const fetchUnlike = createAsyncThunk("video/fetchUnlike", async ({ id, unlikes }) => {
  const video = await updateUnlike(id, unlikes);
  return video;
});

const videoSlice = createSlice({
  name: "video",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideo.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.video = action.payload;
        state.isLoading = false;
        state.isError = false;
        state.error = "";
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.video = {};
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(fetchLike.fulfilled, (state, action) => {
        state.video = action.payload;
      })

      .addCase(fetchLike.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(fetchUnlike.fulfilled, (state, action) => {
        state.video = action.payload;
      })

      .addCase(fetchUnlike.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export default videoSlice.reducer;
